import Config from 'Config';
import axios from 'axios';
import { createSignedRequest } from 'utils/createSignedRequest';

export default async function deleteApprovalGroup(projectId, groupCode) {
  const apiPath = `approvals/delete-approval-group/${projectId}/${groupCode}`;

  const request = {
    // url: `http://localhost:3001/${apiPath}`,
    url: `https://${process.env.REACT_APP_WORK_CALENDAR_API_URL}/${apiPath}`,
    host: process.env.REACT_APP_WORK_CALENDAR_API_URL,
    path: apiPath,
    method: 'DELETE',
    region: Config.AWS_REGION,
    service: 'execute-api',
  };

  const signedRequest = await createSignedRequest(request);

  const response = await axios(signedRequest);

  return response.data;
}
